import { Menu, Spin, Typography } from "antd";
import StyledTenantList from "./styles";
import { useTenants } from "../../../hooks/useTenants";
import { useDispatch } from "react-redux";
import { setKeyValue } from "../../../store/user/slice";

const { Title } = Typography;

const TenantList = () => {
  const { tenants, loading, selectedTenantId } = useTenants();
  const dispatch = useDispatch();

  return (
    <StyledTenantList xs={24} md={5} className="h-100 flex-col tenant-list">
      <Title level={4} className="tenant-title flex-centre">
        Select Business
      </Title>

      {loading ? (
        <div className="flex-center">
          <Spin />
        </div>
      ) : (
        <Menu
          mode="inline"
          onSelect={({ key }) =>
            dispatch(setKeyValue({ key: "selectedTenantId", value: key }))
          }
          selectedKeys={[selectedTenantId]}
          items={tenants.map((t) => ({
            key: t.id,
            label: t.name,
          }))}
        />
      )}
    </StyledTenantList>
  );
};

export default TenantList;
